export const requiredText = 'تکمیل این فیلد اجباری است.';

export const PUBLIC_REQUIRED_RULE = { value: true, message: requiredText };
